import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoArrowBack, IoCheckmarkCircleOutline } from 'react-icons/io5';
import { useAuth } from '../context/AuthContext';
import { checkPermission, PERMISOS_SAAS } from '../utils/permisos';
import { db } from '../firebaseConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';
import './GestionFacturasScreen.css'; // Reusando layout
import './HomeScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import SafeAreaInsets from '../components/Shared/SafeAreaInsets';
import './DispersionNominaScreen.css';

function DispersionNominaScreen() {
    const navigate = useNavigate();
    const location = useLocation();
    const { userData } = useAuth();
    
    const [nominasAprobadas, setNominasAprobadas] = useState([]);
    const [loading, setLoading] = useState(false);

    // Seguridad: Determinar contexto
    const isSaaS = location.pathname.includes('/superuser');
    const basePath = isSaaS ? '/superuser/hr' : '';
    const activeRoute = isSaaS ? "/superuser/hr/dispersion-nomina" : "/superuser/hr/dispersion-nomina"; // Standard active path

    // Chequeo estricto de permisos
    useEffect(() => {
        if (!userData) return;

        if (isSaaS && !checkPermission(userData, PERMISOS_SAAS.ACCESO_MODULO_DISPERSION)) {
            alert('Acceso Denegado: No cuentas con el permiso para acceder al Módulo de Dispersión y Timbrado.');
            navigate(`${basePath}/nominas-dashboard`);
        }
        
        // Mock de carga de nóminas pendientes (Fase MVP)
        // setLoading(true);
        // ... Logica de lectura de colección 'nominas' con estatus 'Aprobada'
        // setLoading(false);
        
    }, [userData, isSaaS, navigate, basePath]);

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute={activeRoute} />
            <main className="ks-main">
                <SafeAreaInsets top={false} bottom={true} />
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    <div className="gestion-facturas-container" style={{ padding: '20px', paddingTop: '0px', paddingBottom: '100px', maxWidth: '100%', minHeight: 'auto', background: 'transparent' }}>
                        {/* OMNI-BANNER */}
                        <div className="usuarios-fixed-wrapper" style={{ position: 'relative', marginTop: '0px' }}>
                            <div className="usuarios-banner-compact" style={{ background: isSaaS ? 'linear-gradient(135deg, #7c3aed 0%, #4c1d95 100%)' : 'linear-gradient(135deg, #0f172a 0%, #3b82f6 100%)' }}>
                                <button onClick={() => navigate(`${basePath}/dashboard`)} className="usuarios-back-btn glass" title="Atrás">
                                    <IoArrowBack size={24} />
                                </button>
                                <div className="usuarios-banner-content">
                                    <h2>Dispersión y Timbrado</h2>
                                    <p>{isSaaS ? 'Pago a empleados y sellado CFDI' : 'Nómina Operativa'}</p>
                                </div>
                            </div>
                        </div>

                        <div className="facturas-layout">
                            <div className="facturas-sidebar glass-card">
                                <h3 className="sidebar-title">Acciones de Emisor</h3>
                                <ul className="sidebar-menu">
                                    <li className="active">Nóminas por Pagar</li>
                                    <li>Histórico Dispersado</li>
                                    <li>Cancelaciones (Sustitución)</li>
                                    <li>Consulta de Folios API SAT</li>
                                </ul>
                            </div>

                            <div className="facturas-content glass-card">
                                <div className="facturas-header">
                                    <h2>Órdenes de Pago de Nómina</h2>
                                </div>
                                
                                {loading ? (
                                    <div className="loading-state">Consultando Nóminas Aprobadas...</div>
                                ) : (
                                    <div className="empty-state">
                                        <IoCheckmarkCircleOutline size={48} className="empty-icon text-green-500" />
                                        <h3>Todo al día</h3>
                                        <p>No existen nóminas con estatus 'Aprobada' pendientes de dispersión bancaria.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <KondoBottomNav activeRoute={activeRoute} />
            </main>
        </div>
    );
}

export default DispersionNominaScreen;
